var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcVideoDuration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231815",
    fillRule: "evenodd",
    d: "M12 19c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7m0-16a9 9 0 100 18 9 9 0 000-18m3.447 10.105L13 11.882V8a1 1 0 10-2 0v4.5c0 .05.021.091.028.14.011.071.017.143.043.211.022.061.06.11.093.165.034.056.062.11.106.158.05.053.11.09.17.133.04.027.068.066.112.088l3 1.5a1.002 1.002 0 00.895-1.79",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3E %3Cpath fill='%23231815' fill-rule='evenodd' d='M12 19c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7m0-16c-4.971 0-9 4.03-9 9 0 4.971 4.029 9 9 9s9-4.029 9-9c0-4.97-4.029-9-9-9m3.447 10.105L13 11.882V8c0-.553-.448-1-1-1-.553 0-1 .447-1 1v4.5c0 .05.021.091.028.14.011.071.017.143.043.211.022.061.06.11.093.165.034.056.062.11.106.158.05.053.11.09.17.133.04.027.068.066.112.088l3 1.5c.144.07.296.106.447.106.367 0 .72-.204.895-.553.247-.495.047-1.096-.447-1.343' clip-rule='evenodd'/%3E %3C/svg%3E";
export { SvgIcVideoDuration as ReactComponent };